"use client";

import { useState } from "react";
import LinksGrid from "./LinksGrid";
import SectionHeader from "./SectionHeader";
import TabSwitcher from "./TabSwitcher";

export default function TabbedLinkList({
  title,
  description,
  tabs = [],
  className = "",
  gridCols = {
    mobile: 2,
    tablet: 3,
    desktop: 3,
    large: 3,
  },
}) {
  const [activeTab, setActiveTab] = useState(0);

  // tabs array format: [{ id: "tab1", title: "Tab 1", items: [{ label: "Link 1", href: "/link1" }] }]

  if (!tabs || tabs.length === 0) {
    return null;
  }

  const currentTabData = tabs[activeTab] || tabs[0];
  return (
    <div className="space-y-4">
      <SectionHeader title={title} />

      {tabs.length > 1 && (
        <TabSwitcher
          tabs={tabs.map((tab, index) => ({ id: index, label: tab.title }))}
          selected={activeTab}
          onChange={setActiveTab}
          className="mb-6"
        />
      )}

      <LinksGrid
        title=""
        items={currentTabData.items || []}
        className="mt-6"
        gridCols={gridCols}
      />
    </div>
  );
}
